import React from 'react';

import Layout from '../uglib_components/layout';

import ContactForm from '../uglib_components/contactForm';
import AskChat from '../uglib_components/askChat';
import { Helmet } from 'react-helmet';




const IndexPage = ({ data, location }) => {

	/**
	 * If the page wasn't accessed at /contact-us provide a cannoncial URL that points to that page. 
	 */
	let head = <></>;
	const url = location.href ? location.href : '';

	if(!url.includes('contact-us')) {
		head = <Helmet>
			<link rel="canonical" href={"https://www.lib.uoguelph.ca/contact-us"} />
		</Helmet> 
	}

    return (
        <Layout title="Contact Us" keywords={['library', 'research', 'guelph']} bodyClass='contact'>     
			{head}
            <div className="container page-container">
				<div className="row">
					<div className="col-md-6">
						<h2>Visit Us</h2>
						<p><a href="https://www.google.com/maps?ll=43.531479,-80.227774&amp;z=16&amp;t=m&amp;hl=en-US&amp;gl=CA&amp;mapclient=embed&amp;q=McLaughlin+Library+480+Gordon+St+Guelph,+ON+N1G+1Y4">McLaughlin Library</a><br />
						University of Guelph<br />
						50 Stone Road East, Guelph, Ontario, N1G 2W1</p>
						<ul>
							<li><a href="/service-hours">Library hours</a></li>
							<li><a href="https://www.parking.uoguelph.ca/">Parking information</a></li>
						</ul>
						<p><a href="/using-library/spaces/tug-annex/">TriUniversity Group Annex</a><br />110 Malcolm Rd, Guelph, Ontario, N1K 1B1</p>
						<h2>Speak With Us</h2>
						<ul>
							<li>Main Phone: <a href="tel:519-824-4120p53617">(519) 824 - 4120 x53617</a></li>
							<li>Ask Us Desk: <a href="tel:519-824-4120p53618">(519) 824 - 4120 x53618</a></li>
							<li>IT Help: <a href="tel:519-824-4120p58888">(519) 824 - 4120 x58888</a></li>
							<li>Archival &amp; Special Collections: <a href="tel:519-824-4120p53413">(519) 824 - 4120 x53413</a></li>
							<li>TUG Annex: <a href="tel:519-821-7946">(519) 821-7946</a></li>
							<li><a href="/about/staff-directory" id="staff-directory">Staff Directory</a></li>
							<li>In person at the <a href="/where/areas/area/circinfo">Ask Us Desk</a></li>
						</ul>
						<h2>More Information</h2>
						<ul>
						<li>Check out the <a href="/using-library/frequently-asked-questions-faq">Library FAQs</a></li>
						<li><a href="https://uglibrary.instatus.com/">Library System Status Page</a></li>
						</ul>
					</div>
					<div className="col-md-6">
						<h2>Email Us</h2>
						<p>Have a question, comment, or suggestion? Please email us using the form below or email <a href="mailto:library@uoguelph.ca">library@uoguelph.ca</a>. We normally respond within one business day.</p>
						<ContactForm />	
					</div>	
				</div>
				
            </div>
        </Layout>
    );
}

export default IndexPage